import { gql } from "@apollo/client";

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword ($oldPassword: String!, $newPassword: String!) {
    changePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
      message
    }
}
`;
